import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const FullAppFallback = () => {
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: `
                    @import url('https://fonts.googleapis.com/css?family=Montserrat&display=swap');

                    :root {
                        --colorPrimary: #172235;
                        --colorSecondary: #ecebf7;
                        --colorAccent: #126a78;
                        --colorBackground: linear-gradient(
                            128.32deg,
                            #fdfdfd 3.91%,
                            #ebf3f4 94.19%
                        );
                        --colorGrey: #6a717d;
                    }

                    body {
                        font-family: 'Montserrat', sans-serif;
                        font-size: 1.6rem;
                        padding: 0;
                        margin: 0;
                    }
                    .crash-screen {
                        display: flex;
                        width: 100%;
                        height: 100vh;

                        flex-direction: column;
                        background: var(--colorBackground);
                    }
                    .crash-screen__content {
                        display: flex;
                        max-width: 1200px;
                        width: calc(100% - 48px);
                        height: 100vh;
                        margin: auto 24px;

                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                    }
                    .crash-screen__responsive-wrapper {
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                    }
                    .crash-screen__text {
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                    }
                    .crash-screen__error-code {
                        font-family: 'GT Super Display', sans-serif;
                        font-weight: normal;
                        font-size: 1.4rem;
                        line-height: 1.43;
                        letter-spacing: 0.12rem;
                        color: var(--colorAccent);
                    }
                    .crash-screen__title {
                        font-family: 'GT Super Display';
                        font-feature-settings: 'pnum' on, 'lnum' on;
                        font-weight: 400;
                        font-style: normal;
                        font-size: 4.8rem;
                        line-height: 1.08;
                        letter-spacing: -0.15rem;
                        color: var(--colorPrimary);
                    }
                    .crash-screen__description {
                        font-family: 'GT Super Display', sans-serif;
                        font-weight: 400;
                        font-style: normal;
                        font-size: 1.6rem;
                        line-height: 1.37;
                        letter-spacing: -0.0015rem;
                    }
                    .crash-screen__bold {
                        font-weight: bold;
                    }
                    .crash-screen__button {
                        border: none;
                        border-radius: 8px;
                        padding: 8px;
                        color: var(--colorPrimary);
                        cursor: pointer;
                        background-color: transparent;

                        font-size: 15px;
                        font-weight: normal;
                        line-height: 26px;

                        display: flex;
                        max-height: 44px;
                        min-width: fit-content;
                        justify-content: center;
                        align-self: start;
                        margin-top: 24px;
                    }
                    .leaf__logo {
                        max-height: 30px;
                        margin-left: 8px;
                    }
                    .crash-screen__card {
                        background-color: white;
                        border-radius: 8px;
                        box-shadow: 0px 5px 8px -2px rgba(30, 0, 86, 0.15),
                            0px 0px 1px rgba(30, 0, 86, 0.31);
                        padding: 16px;
                    }
                    .crash-screen__resources_button {
                        width: 100%;
                        background-color: var(--colorSecondary);
                        color: var(--colorPrimary);
                    }
                    .crash-screen__zero_margin_right {
                        margin-right: 0 !important;
                    }
                    .crash-screen__searchbox {
                        border-radius: 8px;
                        width: 100%;
                        height: 48px;
                    }
                    .crash-screen__search_button {
                        background-color: var(--colorPrimary);
                        color: white;
                        height: 44px;
                        margin: 0 !important;
                    }
                    .crash-screen__margin_bottom {
                        margin-bottom: 24px;
                    }
                    @media only screen and (min-width: 600px) {
                        .crash-screen__content {
                            margin: auto;
                        }
                        .crash-screen__responsive-wrapper {
                            flex-direction: row;
                        }
                        .crash-screen__card {
                            margin: 24px;
                            width: 100%;
                        }
                        .crash-screen__text {
                            margin-left: 24px;
                        }
                        .crash-screen__button {
                            align-self: center;
                            margin-right: 24px;
                        }
                        .crash-screen__searchbox {
                            margin-right: 24px;
                        }
                    }
                ` }), _jsx("div", { className: "crash-screen", children: _jsxs("div", { className: "crash-screen__content", children: [_jsxs("div", { className: "crash-screen__responsive-wrapper crash-screen__margin_bottom", children: [_jsxs("div", { className: "crash-screen__text", children: [_jsx("div", { className: "crash-screen__error-code", children: "500" }), _jsx("div", { className: "crash-screen__title", children: "Internal server error" }), _jsx("div", { className: "crash-screen__description", children: "We are experiencing some difficulty loading this page." })] }), _jsxs("button", { className: "crash-screen__button", onClick: () => {
                                        window.location.href = '/today/microsteps';
                                    }, children: ["Go to main page", _jsx("img", { className: "leaf__logo", src: "https://assets.thriveglobal.com/company_logos/Thrive-Mark-Multi-LowRes.png" })] })] }), _jsx("div", { className: "crash-screen__responsive-wrapper", children: _jsxs("div", { className: "crash-screen__card", children: [_jsx("div", { className: "crash-screen__description crash-screen__bold", children: "Want to try something else?" }), _jsx("div", { className: "crash-screen__description", children: "Experience best in class content to help you reduce stress, build resilience, and take action with Microsteps." }), _jsxs("div", { className: "crash-screen__responsive-wrapper", children: [_jsx("button", { className: "crash-screen__button crash-screen__resources_button", onClick: () => {
                                                    window.location.href = '/reset';
                                                }, children: "Resets" }), _jsx("button", { className: "crash-screen__button crash-screen__resources_button", onClick: () => {
                                                    window.location.href = '/learn';
                                                }, children: "Library" }), _jsx("button", { className: "crash-screen__button crash-screen__resources_button crash-screen__zero_margin_right", onClick: () => {
                                                    window.location.href = '/challenges';
                                                }, children: "Challenges" })] })] }) })] }) })] }));
};
//# sourceMappingURL=FullAppFallback.js.map